<template>
  <add-edit-real
    v-if="show"
    @reset="reset"
    :commandId="commandId"
    :isSee="isSee"
  ></add-edit-real>
</template>

<script>
import AddEditReal from "./AddEditReal.vue";
export default {
  components: {
    AddEditReal,
  },
  props: {
    commandId: {
      type: String,
      require: false,
      default() {
        return null;
      },
    },
    isSee: {
      type: String,
      require: false,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    async reset() {
      this.show = false;
      await this.$nextTick();
      this.show = true;
    },
  },
};
</script>

<style>
</style>